const FORMAT_NUMBERS = {
    LOCALE: 'en-US',
    CURRENCY: 'USD',
    MINIMUM_FRACTION_DIGITS: 2,
    MAXIMUM_FRACTION_DIGITS: 2
};

/**
 * function that formats a number and returns a string
 * e.g. formatNumber(1234) -> '$1,234.00'
 * @param {number} value - number to be formatted
 * @param {string} locale - number's locale (format) e.g. 'en-US'
 * @param {string} currency - number's currency e.g. 'USD'
 * @param {number} minimumFractionDigits
 * @param {number} maximumFractionDigits
 * @returns {string}
 */

export const formatNumberDefault = new Intl.NumberFormat(FORMAT_NUMBERS.LOCALE, {
    style: 'currency',
    currency: FORMAT_NUMBERS.CURRENCY,
    minimumFractionDigits: FORMAT_NUMBERS.MINIMUM_FRACTION_DIGITS,
    maximumFractionDigits: FORMAT_NUMBERS.MAXIMUM_FRACTION_DIGITS
}).format;
